import { BaseDataTransferObject } from '../base-data-transfer-object';

export enum BillTo {
    Insurance,
    Client,
    Patient,
    None,
}

export class BillType extends BaseDataTransferObject {
    public code: string;
    public name: string;
    public allPayers: boolean;

    constructor({code, name, allPayers}: {code: string, name: string, allPayers: boolean}) {
      super();
      this.code = code;
      this.name = name;
      this.allPayers = allPayers;
    }
}

export class BillTypeWithPayers extends BillType {
    public payers?: number[] = undefined;
}

